export default __webpack_public_path__ + "static/media/58-OneDropOneNight.9fc35fa9.jpg";